<template>
  <div class="page-news">
    <div class="news-banner">
      <el-carousel trigger="click" height="438px" :interval="interval" :autoplay="autoplay" arrow="never" @change="onChange">
        <!-- indicator-position="outside" -->
        <el-carousel-item v-for="(item,index) in bannerList" :key="item.id" :name="item.id + ''">
          <!-- :label="item.id" -->
          <router-link :to="`/news/detail?id=${item.id || ''}`" class="banner-item">
            <!-- <img :src="item.image | baseImg" class="img" /> -->
            <video
                class="video"
                muted
                autoplay
                :id="'videoPlayer' + index"
                :src="item.image"
                @ended="videEnd($event)"
                v-if="item.image_type === 1"
                ></video>
            <img :src="item.image" v-else class="img" style="width:100%;" alt=""/>
            <div class="tit">
              <span class="z-line-1" style="width: 80%">{{ item.title }}</span>
            </div>
          </router-link>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="news-tabs">
      <div class="tab-items">
        <div class="tab-item" :class="{ active: activeIndex === i }" @click="tabClick(i, item)"
          v-for="(item, i) in newsList" :key="item.id" @mouseover="tabHover(i)">
          {{ item.name }}
        </div>
      </div>
      <div class="news-tab-items" v-for="(item, i) in newsList" :key="item.id" v-show="activeIndex === i">
        <router-link class="news-tab-item" :to="{
          name: 'news_detail',
          query: {
            id: item2.id,
            name: item.name,
          },
        }" v-for="item2 in item.article_list" :key="item2.id">
          <div class="tit z-line-1" :title="item2.title">{{ item2.title }}</div>
          <div class="time">{{ item2.addtime | dayjs("year-date") }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNewsBanner,
  getNewsByCategoryId,
  getNewsCategoryList,
} from "@/apis/news";

export default {
  name: "NewsMain",
  data() {
    return {
      autoplay: true,
      bannerList: [],
      newsList: [],
      activeIndex: 0,
      interval: 4000,
      duration: 0, // 当前视频的总时长
      bannerIndex: 0,
    };
  },
  created() {
    this.getNewsBanner();
    this.getNewsCategoryList();
  },
  methods: {
    // 视频播放完成
    videEnd(index) {
      console.log(index)
      document.getElementById('videoPlayer' + this.bannerIndex).currentTime = 0
      this.autoplay = true;
      this.interval = 100;
    },
    // 监听轮播图改变
    onChange(index) {
      // 如果是视频,就等播放完再进行下一个
      this.bannerIndex = index;
      if (this.bannerList[index].image_type === 1) {
        console.log(document.getElementById('videoPlayer' + index))
        this.duration = document.getElementById('videoPlayer' + index).duration
        this.interval = this.duration * 1000;
        this.autoplay = false;
      }else {
        this.interval = 4000;
        this.autoplay = true;
      }
    },
    tabHover(i) {
      this.activeIndex = i;
    },
    async getNewsBanner() {
      const { data } = await getNewsBanner();
      this.bannerList = data;
      this.$nextTick(() => {
        if (this.bannerList[0].image_type === 1) {
          const myVideo = document.getElementById('videoPlayer0');
          // eslint-disable-next-line no-unused-vars
          let videTime;
          myVideo.onloadedmetadata = function () {
            console.log('视频长度为：',myVideo.duration.toFixed(2))
            videTime = myVideo.duration.toFixed(2)
          };
          this.interval = videTime * 1000;
          this.autoplay = false;
        }
      })
    },
    async getNewsCategoryList() {
      const { data } = await getNewsCategoryList();
      this.newsList = data;
      data.forEach((v, i) => {
        this.getNewsByCategoryId(v.id, i);
      });
    },
    async getNewsByCategoryId(id, index) {
      const { data } = await getNewsByCategoryId({
        c_id: id,
        page: 1,
        pagenum: 9,
      });
      this.$set(this.newsList[index], "article_list", data.data);
    },
    tabClick(index, item) {
      this.activeIndex = index;
      this.$router.push({
        name: "news_category",
        params: {
          id: item.id,
        },
        query: {
          name: item.name,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-news {
  display: flex;
}

.news-banner {
  // width: 744px;
  // height: 574px;
  width: 768px;
  height: 438px;
}

.news-tabs {
  flex: 1;
  // width: calc(100% - 768px);
  padding-left: 20px;

  .tab-items {
    display: flex;
    // width: 596px;
    border-bottom: 2px solid rgba(235, 238, 245, 0.39);

    .tab-item {
      font-size: 20px;
      font-size: var(--font-size-20);
      font-weight: bold;
      line-height: 28px;
      text-align: center;
      border-bottom: 4px solid transparent;
      padding: 0 10px 8px 10px;
      color: #303133;
      cursor: pointer;

      &.active {
        border-color: rgba(13, 124, 228, 1);
        color: #0d7ce4;
      }

      &:hover {
        color: #0d7ce4;
      }
    }
  }
}
</style>
